import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dccs-edit',
    templateUrl: './dccs-edit.component.html',
    styleUrls: ['./dccs-edit.component.scss']
})
export class DccsEditComponent implements OnInit {

    constructor(
        private route: ActivatedRoute,
        private http: HttpService,
        private location: Location,
        public fileHandler: FileHandlerService,
        public loading: LoadingService,
        private el: ElementRef,
        private fb: FormBuilder,
        private toastr: ToastrService
    ) {
        this.route.params.subscribe(e => {
            this.id = e.id;
        });
    }
    private apiPath = 'dccs';
    id: any;
    @ViewChild('theForm') theForm: NgForm | undefined;
    formGroup = this.fb.group({});
    details: any[] = [];
    formChanged = false;
    voice: any = { view: '' };
    question: any = {};
    assetUrl = environment.assetUrl;
    deleted_details: any[] = [];

    submitForm(form: any): void {
        if (!form.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0].focus();
            return;
        }
        let files = this.details.filter((e: any) => e.image?.view);
        if (!files.length) {
            this.toastr.error('Plese upload answer choice image', 'Error');
            return;
        }
        if (files.length < 2) {
            this.toastr.error('Minimun anwer choice is 2', 'Error');
            return;
        }
        if (!files.filter((e: any) => e.is_true).length) {
            this.toastr.error('Mark 1 correct answer', 'Error');
            return;
        }

        let fdata = new FormData();
        form.value.bordered = Number(form.value.bordered);
        form.value.details = [];
        files.forEach((e: any) => {
            let img;
            if (e.image?.file) {
                img = e.image.file;
            } else {
                img = new Blob([''], { type: 'application/x-empty' });
            }
            fdata.append('images[]', img);
            form.value.details.push({ is_true: e.is_true, id: e.id });
        })
        form.value.deleted_details = this.deleted_details;
        fdata.append('voice', this.voice.file);
        fdata.append('question', this.question.file);
        fdata.append('data', JSON.stringify(form.value));
        form.disable();
        this.http.PostFile(this.apiPath + '/update', fdata).then((r: any) => {
            form.enable();
            if (r.success) {
                this.toastr.success('Data saved successfully', 'Success');
                this.back();
            } else {
                if (r.response && r.response.wrong) {
                    Object.keys(r.response.wrong).forEach((key) => {
                        form.get(key)?.setErrors({ serverError: r.response.wrong[key][0] });
                        this.el.nativeElement.querySelectorAll('[formcontrolname="' + key + '"]')?.[0]?.focus();
                    });
                }
            }
        });
    }

    addDetails(): void {
        this.details.push({ is_true: 0, image: {} });
    }

    removeDetails(i: number): void {
        if (this.details[i].id) {
            this.deleted_details.push(this.details[i].id);
        }
        this.details.splice(i, 1);
        if (!this.details.length) {
            this.addDetails();
        }
    }

    browseImage(i: number): void {
        this.el.nativeElement.querySelectorAll('#input-image-' + i)?.[0]?.click();
    }

    isTrue(ev: any, i: number) {
        if (ev.target?.checked) {
            this.details.forEach((e: any) => e.is_true = 0);
        }
        this.details[i].is_true = Number(ev.target?.checked);
    }

    back(): void {
        this.location.back();
    }

    ngOnInit(): void {
        this.http.Get(this.apiPath + '/' + this.id, {}).then((r: any) => {
            if (r.success && r?.response?.result?.data?.id) {
                Object.keys(r?.response?.result?.data).forEach((key) => {
                    this.formGroup.addControl(key, new FormControl(r?.response?.result?.data[key]));
                });
                this.voice.view = r.response.result.data.voice || '';
                this.question = { file: { name: r.response.result.data.question } };
                r.response.result.data.details.forEach((e: any) => {
                    this.details.push({
                        id: e.id,
                        is_true: e.is_true,
                        image: {
                            view: this.assetUrl + e.image
                        }
                    })
                });
            } else {
                this.back();
            }
        });
    }

}
